
export const HB_AUTH_GROUP = [
    process.env.VUE_APP_AUTH_URL,
    process.env.VUE_APP_AUTH_RESOURCE_URL
]

export const HB_MAIN_GROUP = [
    process.env.VUE_APP_PROFILE_API_URL
]

export const HB_SUB_GROUP = [
    process.env.VUE_APP_BOARD_API_URL
]
